/**
 * PromoteAgentCard
 * 
 * @Author: Focci
 * @Date: 2023-10-09 16:14:42
 * @Last Modified by: Focci
 * @Last Modified time: 2023-10-09 16:14:42
 */

import PropTypes from 'prop-types'
import AspectRatioCover from '@comp/AspectRatioCover'
import Link from 'next/link'
import AgentAvatar from '@comp/page/agent/AgentAvatar'
import { useLocale, useTranslations } from 'next-intl'
import { ButtonBase } from '@comp/material'
import { detail } from '@lib/route/agent'

export default function PromoteAgentCard({
  data = {},
  onEstimateFreeButtonClick = () => {},
  actions
}) {
  const locale = useLocale()
  const th = useTranslations('house')

  return (
    <div className="border flex flex-col rounded-[.4rem] overflow-hidden bg-white">
      <div
        className="h-8 flex items-center justify-center"
        style={{ backgroundColor: data.underline_color }}
      >
        <div className="w-16">
          <AspectRatioCover
            brand=""
            className="object-contain"
            src={data.office_oss_avatar}
            width={80}
            height={25}
            alt={data.office_name}
          />
        </div>
      </div>
      <div className="p-4 flex items-center gap-x-4">
        <div className="w-[3.5rem] shrink-0">
          <AgentAvatar
            name={data.name}
            avatar={data.icon}
            membershipLevel={data.membership_level}
            width={70}
            height={70}
            wrapperClassName="rounded-full w-[3.5rem]"
            className="object-cover rounded-full object-top bg-cf0"
            iconClassName="w-10 left-1/2 -translate-x-1/2 -bottom-1"
          />
          {/* <AspectRatioCover
            brand=""
            className="object-cover rounded-full"
            src={data.icon}
            width={70}
            height={70}
            alt={data.name}
          /> */}
        </div>
        <div>
          <b className="text-f.9 leading-none">{data.name}</b>
          <div className="text-meta mt-1">{data.job_title}</div>
        </div>
      </div>
      {data.list_stat && (
        <div className="px-4 flex flex-wrap gap-x-6 gap-y-2">
          <div className="flex flex-col">
            <span className="text-f.6 text-meta">
              {th('medianSalesPrice')}
            </span>
            <b className="text-f.9">
              {data.list_stat.sold_avm_label}
            </b>
          </div>
          <div className="flex flex-col">
            <span className="text-f.6 text-meta">
              {th('numberOfSales')}
            </span>
            <b className="text-f.9">
              {data.list_stat.sold_count}
            </b>
          </div>
        </div>
      )}
      <div className="p-4 flex flex-col gap-2 mt-auto">
        {actions}
        <ButtonBase 
          className="rounded-md w-full"
          onClick={onEstimateFreeButtonClick}
        >
          <div className="rounded-md bg-[#ff5533] text-white w-full text-center p-2">
            {th('valuationFree')}
          </div>
        </ButtonBase>
        <Link 
          className="rounded-md w-full"
          href={detail(data.slug, locale)}
        >
          <div className="rounded-md w-full text-center p-2 border">
            {th('viewAgentDetail')}
          </div>
        </Link>
      </div>
    </div>
  )
}

PromoteAgentCard.propTypes = {
  data: PropTypes.object,
}
